/* GRIPTEK — theme.js */

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll effect ──
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile nav toggle ──
  const navToggle = document.getElementById('nav-toggle');
  const mainNav = document.getElementById('main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', () => {
      mainNav.classList.toggle('open');
      const isOpen = mainNav.classList.contains('open');
      navToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // ── Product gallery thumbnails ──
  const thumbBtns = document.querySelectorAll('.thumb-btn');
  const mainImg = document.getElementById('main-img');
  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      if (mainImg) {
        mainImg.src = btn.dataset.src;
      }
    });
  });

  // ── Variant selector ──
  const variantSelect = document.getElementById('variant-select');
  const optionSwatches = document.querySelectorAll('.option-swatch input');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const addToCartLabel = addToCartBtn ? addToCartBtn.querySelector('span') : null;
  const ADD_TO_CART_TEXT = addToCartLabel ? addToCartLabel.textContent : 'Add to Cart';

  if (optionSwatches.length && variantSelect) {
    optionSwatches.forEach(input => {
      input.addEventListener('change', () => {
        // Update selected class on siblings
        const group = input.closest('.option-values');
        group.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('selected'));
        input.closest('.option-swatch').classList.add('selected');

        // Build selected options array
        const groups = document.querySelectorAll('.option-values');
        const selected = [];
        groups.forEach(g => {
          const checked = g.querySelector('input:checked');
          if (checked) selected.push(checked.value);
        });

        // Find matching variant
        const options = Array.from(variantSelect.options);
        const match = options.find(opt => {
          const variantData = opt.dataset;
          return selected.every((val, i) => {
            const key = `option${i + 1}`;
            return variantData[key] === val;
          });
        });

        if (match) {
          variantSelect.value = match.value;
          const isAvailable = match.dataset.available === 'true';
          if (addToCartBtn) {
            addToCartBtn.disabled = !isAvailable;
            if (addToCartLabel) {
              addToCartLabel.textContent = isAvailable ? ADD_TO_CART_TEXT : 'Out of Stock';
            }
          }

          // ── Swap gallery image if this variant has a dedicated photo ──
          if (match.dataset.image && mainImg) {
            mainImg.src = match.dataset.image;
            document.querySelectorAll('.thumb-btn').forEach(b => b.classList.remove('active'));
            const matchingThumb = document.querySelector(`.thumb-btn[data-src="${match.dataset.image}"]`);
            if (matchingThumb) matchingThumb.classList.add('active');
          }

          // ── Filter thumbnails to this variant's color when color-specific images exist ──
          const variantId = match.dataset.variantId;
          const allThumbs = document.querySelectorAll('.thumb-btn');
          const hasAnyVariantThumbs = Array.from(allThumbs).some(t => t.dataset.variantIds && t.dataset.variantIds.length);
          if (hasAnyVariantThumbs && variantId) {
            allThumbs.forEach(t => {
              const ids = (t.dataset.variantIds || '').split(',').filter(Boolean);
              const isGeneric = ids.length === 0;
              const belongsToVariant = ids.includes(variantId);
              t.style.display = (isGeneric || belongsToVariant) ? '' : 'none';
            });
          }
        } else if (addToCartBtn) {
          addToCartBtn.disabled = true;
          if (addToCartLabel) addToCartLabel.textContent = 'Unavailable';
        }
      });
    });
  }

  // ── Qty buttons ──
  const qtyInput = document.getElementById('qty-input');
  const qtyMinus = document.querySelector('.product-form .qty-minus');
  const qtyPlus = document.querySelector('.product-form .qty-plus');

  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', () => {
      const val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // ── Quick add to cart ──
  document.querySelectorAll('.quick-add').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const originalLabel = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (res.ok) {
          btn.textContent = '✓ Added!';
          updateCartCount();
          setTimeout(() => {
            btn.textContent = originalLabel || '+ Quick Add';
            btn.disabled = false;
          }, 2000);
        } else {
          const err = await res.json().catch(() => ({}));
          btn.textContent = err.description || err.message || 'Unavailable';
          setTimeout(() => {
            btn.textContent = originalLabel || '+ Quick Add';
            btn.disabled = false;
          }, 2500);
        }
      } catch (e) {
        btn.textContent = originalLabel || '+ Quick Add';
        btn.disabled = false;
      }
    });
  });

  // ── Cart count update ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    } catch (e) {}
  }

  // ── Cart page qty & remove ──
  document.querySelectorAll('.cart-item .qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      const valEl = btn.closest('.cart-item-qty').querySelector('.qty-val');
      let qty = parseInt(valEl.textContent);

      if (btn.classList.contains('qty-minus')) qty = Math.max(0, qty - 1);
      else qty = qty + 1;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      location.reload();
    });
  });

  document.querySelectorAll('.cart-remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      location.reload();
    });
  });

  // ── Product form submit feedback ──
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const addBtn = productForm.querySelector('.btn-add-cart');
      const labelSpan = addBtn.querySelector('span');
      const originalText = labelSpan ? labelSpan.textContent : null;

      const resetButton = (text, delay) => {
        setTimeout(() => {
          if (labelSpan) labelSpan.textContent = text || originalText || 'Add to Cart';
          addBtn.disabled = false;
        }, delay);
      };

      const formData = new FormData(productForm);
      const variantId = formData.get('id');

      if (!variantId) {
        if (labelSpan) labelSpan.textContent = 'Select a variant';
        setTimeout(() => {
          if (labelSpan) labelSpan.textContent = originalText || 'Add to Cart';
        }, 2500);
        return;
      }

      addBtn.disabled = true;
      if (labelSpan) labelSpan.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: formData.get('quantity') || 1
            }]
          })
        });

        if (res.ok) {
          if (labelSpan) labelSpan.textContent = '✓ Added to cart!';
          updateCartCount();
          resetButton(originalText, 2500);
        } else {
          const err = await res.json().catch(() => ({}));
          const message = err.description || err.message || 'Could not add to cart';
          if (labelSpan) labelSpan.textContent = message;
          resetButton(originalText, 3000);
        }
      } catch (e) {
        if (labelSpan) labelSpan.textContent = 'Network error';
        resetButton(originalText, 3000);
      }
    });
  }

  // ── Intersection Observer animations ──
  const animEls = document.querySelectorAll('.feature-card, .testimonial-card, .sport-card, .product-card');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    animEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = `opacity 0.5s ${i * 0.08}s ease, transform 0.5s ${i * 0.08}s ease`;
      observer.observe(el);
    });
  }
});
